module.exports = __webpack_public_path__ + "img/404.865d7dde.png";